export default {

  idCard: "Identity document",
  login: " Log in ",
  password: "Password",
  remeberPassword: "I do not remember my password",
  noAccount: "¿You do not have an account?",
  Signup: "Signup"

}